module.exports = __webpack_public_path__ + "static/karla-regular-10b80825c50001ba344f0dd01baf0a93.woff";